import React, {useState} from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {DateInput, required, Title} from 'react-admin';
import {ReportForm} from '../../components';
import env from '../../env';
import moment from "moment";
import {downloadFilePost} from "../../components/FileDownload";

const SoPhuOCB = (props) => {

    const [loading, setLoading] = useState(false)

    const [state, setState] = useState({
        fromDate: new Date(),
        toDate: new Date(),
    });

    const excelReport = async () => {
        setLoading(true);
        await downloadFilePost(`${env.baseURL}/reports/so-phu-ocb`, 'so-phu-ocb.xlsx', {
            fromDate: moment(state.fromDate).format('YYYY-MM-DD'),
            toDate: moment(state.toDate).format('YYYY-MM-DD'),
        })
        setLoading(false);
    };

    const validate = (values) => {
        const errors = {};
        setState(values);
        return errors;
    };

    return (
        <Card>
            <Title title="resources.so-phu-ocb.name"/>
            <CardContent>
                <ReportForm params={state}
                            validate={validate}
                            excelReport={excelReport}
                            isLoading={loading}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <DateInput label="resources.common.fromDate" source="fromDate"
                                       validate={required()} {...props} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DateInput label="resources.common.toDate" source="toDate"
                                       validate={required()} {...props} />
                        </Grid>
                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    )
}

export default SoPhuOCB

